<template>
	<LazyLoadWrapper>
		<div
			class="w-full grid md:grid-cols-4 grid-cols-2 gap-4 justify-between text-white"
		>
			<div v-for="category in featuredCategories" :key="category.Id">
				<NuxtLink
					:to="
						localePath(
							`/${createCategoryLink({
								category
							})}`
						)
					"
					class="cms-element-image flex relative w-full h-full pb-[68%] cursor-pointer group"
				>
					<div
						class="absolute w-full h-full z-10 flex items-center justify-center bg-black/30"
					>
						<button
							class="button-banner-button !bg-transparent group-hover:!bg-blue-light"
						>
							{{ category.Name }}
						</button>
					</div>

					<NuxtImg
						:src="category?.Files?.[0]?.ImagePath + '?format=webp&w=516'"
						alt=""
						:loading="blok.lazy_load_images ? 'lazy' : 'eager'"
						:preload="blok.lazy_load_images ? false : true"
						format="webp"
						class="h-full w-full absolute inset-0 object-cover object-center"
						sizes="sm:10vw md:50vw lg:70vw 70vw"
					/>
				</NuxtLink>
			</div>
		</div>
	</LazyLoadWrapper>
</template>

<script setup lang="ts">
import type { CategoryWithFiles } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";
import LazyLoadWrapper from "~/components/LazyLoadWrapper.vue";
import { useFetchCategoryTree } from "~/composables/useFetchCategoryTree";
import type { BlokFeaturedCategories } from "~/types/storyblok/storyblok";

const localePath = useLocalePath();

interface Props {
	blok: BlokFeaturedCategories;
}
const { blok } = defineProps<Props>();

const { getSelectedCategories } = useNorcePwa();
const { createCategoryLink } = useCategory();
const { locale } = useI18n();

const featuredCategories = ref<CategoryWithFiles[]>([]);

const getFeaturedCategories = async () => {
	featuredCategories.value = await getSelectedCategories(
		blok?.select_categories?.[0]?.categories?.map((cat) => +cat)
	);
};
const { fetchCategoryTree } = useFetchCategoryTree();

await fetchCategoryTree(locale.value);
await getFeaturedCategories();
</script>
